import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/loader/styles.scss';export default {
  "loader": "_loader_xfpns_1",
  "item": "_item_xfpns_6",
  "checkbox": "_checkbox_xfpns_16",
  "name": "_name_xfpns_24"
};